import React, { useState, useEffect, useContext, useRef } from 'react';
import 'antd/dist/antd.css';
import {
    Table,
    Row,
    Col,
    Tooltip,
    message,
    Typography,
    Space,
    Spin
} from 'antd';

import { getProjectDataToPagination } from 'services/project';

import { useVT } from 'virtualizedtableforantd4';
import icon_menu_dots from 'images/icon_menu_dots.svg';
import SecondSiderTransform from './SecondSiderTransform';
import SmallAside from 'components/navigation/SmallAside';
import keyBy from 'lodash/keyBy';
import cloneDeep from 'lodash/cloneDeep';
import { getProject, getProjectTable } from 'services/project';
import HeaderProject from 'components/header/HeaderProject';
import moment from 'moment';

// import ConditionFormulaDisplay from 'components/content/transformView/ConditionFormulaDisplay';
import { functionFormulaDisplay } from './FunctionFormulaDisplay';

import { AppContext } from 'context/AppContext';
import { useParams } from 'react-router-dom';

import HelpMenu from 'components/navigation/HelpMenu';
import { _l } from 'lib/utils';

import { TransformContext } from './TransformContext';
import DeleteModal from 'components/content/newModal/DeleteModal';
import { deleteColumn, updateColumn } from 'services/column';
import RenameModal from 'components/content/newModal/RenameModal';
import Loader from 'components/Loader';

const TransformView = () => {
    const { Paragraph } = Typography;
    const { projectId } = useParams();
    let currentProject = localStorage.getItem('activeProject');

    const [currentPageToPagination, setCurrentPageToPagination] = useState(1);
    const [loadingScroll, setLoadingScroll] = useState(false);
    const [hasNextPage, setHasNextPage] = useState(true);

    let refTable = useRef();

    let appContext = useContext(AppContext);
    let tContext = useContext(TransformContext);

    useEffect(() => {
        appContext.setCurrentLocation(['3']);
    }, []);

    if (currentProject != projectId && projectId != '') {
        localStorage.setItem('activeProject', projectId);
    }

    const [conditionalName, setConditionalName] = useState('Condition name');

    const [transformVisibleButton, setTransformVisibleButton] =
        useState('numerical');

    const [projectData, setProjectData] = useState({});
    const [rawProjectData, setRawProjectData] = useState({});
    const [tableRender, setTableRender] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [tableColumn, setTableColumn] = useState([]);
    const defaultInputVariableTaker = {
        analysis_id: null,
        taker: false,
        variable: ''
    };

    const [isModalDeleteColumn, setIsModalDeleteColumn] = useState(false);

    const [loadingDataFromServer, setLoadingDataFromServer] = useState(true);

    const [rerenderTable, setRerenderTable] = useState(false);

    const [inputVariableTaker, setInputVariableTaker] = useState({});

    const [rerenderProjectData, setRerenderProjectData] = useState(false);

    const defaultConditionalTransform = [
        {
            id: 1,
            type: 'if',
            condition: [
                {
                    var_a_type: 'Column',
                    var_a: '',
                    var_b_type: 'Value',
                    var_b: '',
                    function: '',
                    and_or: ''
                }
            ],
            then_type: 'Value',
            then: ''
        }
    ];

    const [conditionalItems, setConditionalItems] = useState(
        defaultConditionalTransform
    );

    const [columnDbId, setColumnDbId] = useState(null);
    const [columnName, setColumnName] = useState(null);
    const [conditionalTransform, setConditionalTransform] = useState(null);

    const [formulaToDisplayInTable, setFormulaToDisplayInTable] = useState();
    const [isModalRenameColumn, setIsModalRenameColumn] = useState(false);

    const handleModalRenameColumn = () => {
        setIsModalRenameColumn(!isModalRenameColumn);
    };

    const handleColumnName = (e) => {
        setColumnName(e.target.value);
    };

    const handleRenameColumn = () => {
        updateColumn(columnDbId, { name: columnName }).then((res) => {
            if (res.status == 200) {
                handleModalRenameColumn();
                setRerenderTable(!rerenderTable);
            } else {
                message.error(
                    'Whoops! There seems to be a problem with changing column name.'
                );
            }
        });
    };

    const handleModalDeleteColumn = () => {
        setIsModalDeleteColumn(!isModalDeleteColumn);
    };

    const handleDeleteColumn = () => {
        deleteColumn(columnDbId)
            .then((res) => {
                let cloneTableColumn = cloneDeep(tableColumn);

                cloneTableColumn = cloneTableColumn.filter(
                    (item) => item.col_db_id != columnDbId
                );

                setTableColumn(cloneTableColumn);
                //setRerenderTable(!rerenderTable);
            })
            .catch((err) => {
                console.log(err);

                let errCode = err.response.status;

                if (errCode == 409) {
                    let errMessage = err.response.data.message;

                    message.error(errMessage);
                }
            });

        handleModalDeleteColumn();
    };

    const formulaDisplay = (items) => {
        let formula = [];

        let formulaStack = [];

        for (let item in items) {
            let formulaItem = items[item].hasOwnProperty('niceStart')
                ? items[item]['niceStart']
                : items[item]['text'];

            if (items[item].hasOwnProperty('end'))
                formulaStack.push(items[item]);

            if (items[item]['type'] == 'p-end') {
                formulaItem = formulaStack.pop();
                formulaItem = formulaItem.hasOwnProperty('niceEnd')
                    ? formulaItem['niceEnd']
                    : formulaItem['end'];
            }

            formula.push(formulaItem);
        }

        return formula.join('');
    };

    const renderTableData = (columns, dataTable, now) => {
        for (let i in columns) {
            let title = columns[i]['title'];

            let columnName =
                'C' + columns[i]['dataIndex'] + ': ' + columns[i]['title'];

            if (columns[i]['title'] == '') {
                columnName = 'C' + columns[i]['dataIndex'];
            }
            columns[i]['columnName'] = columnName;

            // columns[i]['filterDropdown'] = ({
            //     setSelectedKeys,
            //     selectedKeys,
            //     confirm,
            //     clearFilters
            // }) => {
            //     <div style={{ padding: 8 }}></div>;
            // };

            columns[i]['filterDropdown'] = ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters
            }) => (
                <div className="custom-dropdown">
                    <button
                        className="button-dropdown"
                        onClick={() => {
                            setColumnName(title);
                            setColumnDbId(columns[i].col_db_id);
                            confirm({ closeDropdown: true });
                            handleModalRenameColumn();
                        }}
                    >
                        Rename Column
                    </button>
                    <br />
                    <button
                        className="button-dropdown"
                        onClick={() => {
                            setColumnDbId(columns[i].col_db_id);
                            confirm({ closeDropdown: true });
                            handleModalDeleteColumn();
                        }}
                    >
                        Delete Column
                    </button>
                </div>
            );

            columns[i]['filterIcon'] = (filtered) => (
                <img src={icon_menu_dots} className="icon-menu-dots-svg" />
            );

            const columnType = columns[i]['type'];
            let tooltipTitle = '';
            if (transformVisibleButton === 'numerical') {
                tooltipTitle = 'Click to select column';

                if (columnType !== 'NUMBER')
                    tooltipTitle = 'Not numerical column';

                if (columns[i]['user_formula_json']) {
                    tooltipTitle = (
                        <div
                            dangerouslySetInnerHTML={{
                                __html:
                                    tooltipTitle +
                                    ` 
                        Formula: ` +
                                    formulaDisplay(
                                        columns[i]['user_formula_json']
                                    )
                            }}
                        ></div>
                    );
                }

                columns[i]['title'] = () => {
                    return (
                        <div>
                            <Tooltip
                                title={tooltipTitle}
                                overlayInnerStyle={{ whiteSpace: 'pre-line' }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center'
                                    }}
                                >
                                    {columnType === 'NUMBER' ? (
                                        <div
                                            className="div-select-column"
                                            onClick={() => {
                                                if (
                                                    columnType === 'NUMBER' ||
                                                    columns[i][
                                                        'conditional_transform'
                                                    ]
                                                ) {
                                                    handleSetVariableFormula(
                                                        columns[i]['dataIndex']
                                                    );
                                                }
                                            }}
                                        >
                                            {columnName}
                                        </div>
                                    ) : (
                                        <div className="div-select-column">
                                            {columnName}
                                        </div>
                                    )}
                                </div>
                            </Tooltip>
                        </div>
                    );
                };
            } else {
                columns[i]['title'] = columnName;
                if (columns[i]['conditional_transform']) {
                    tooltipTitle =
                        tooltipTitle +
                        functionFormulaDisplay(
                            columns[i]['conditional_transform']
                        );

                    columns[i]['title'] = () => {
                        return (
                            <div>
                                <Tooltip title={tooltipTitle}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <div
                                            className="div-select-column"
                                            onClick={() => {
                                                if (
                                                    columnType === 'NUMBER' ||
                                                    columns[i][
                                                        'conditional_transform'
                                                    ]
                                                ) {
                                                    // handleSetVariableConditional(
                                                    //     columns[i]['dataIndex'],
                                                    //     columnName
                                                    // );
                                                    setConditionalName(title);
                                                    setColumnDbId(
                                                        columns[i].col_db_id
                                                    );
                                                    setConditionalTransform(
                                                        columns[i]
                                                            .conditional_transform
                                                    );
                                                }
                                                // console.log(`columns`, columns[i].conditional_transform)
                                                // console.log(`dataTable`, dataTable)
                                                setConditionalItems(columns[i].conditional_transform)

                                            }}
                                        >
                                            {columnName}
                                        </div>
                                    </div>
                                </Tooltip>
                            </div>
                        );
                    };
                }
            }
        }

        setTableData(dataTable);
        setTableColumn(columns);
    };

    useEffect(() => {
        setTimeout('', 1000);
        let currentProject = localStorage.getItem('activeProject');

        getProject(currentProject)
            .then((res) => {
                const data = keyBy(res.data.analysis, 'id');

                setProjectData(res.data);
                if (res.data.status === 'processing') {
                    setTimeout(() => {
                        setRerenderProjectData(!rerenderProjectData);
                    }, 3000);
                }

                if (res.status === 200) {
                    setLoadingDataFromServer(false);
                }
            })

            .catch((err) => {
                console.log(err);
            });
    }, [rerenderProjectData, rerenderTable, transformVisibleButton]);

    useEffect(() => {
        let currentProject = localStorage.getItem('activeProject');
        let reportTime = moment().format('HH:mm:ss');
        if (projectData.status === 'done') {
            getProjectTable(currentProject)
                .then((res) => {
                    // console.log(`res From TransformView, ${JSON.stringify(res)}`)
                    console.log(`Get time Table: ${reportTime}`)
                    
                    setRawProjectData(res);
                })

                .catch((err) => {
                    console.log(err);
                });
        }
    }, [projectData]);

    useEffect(() => {
        if ('data' in rawProjectData) {
            let columns = cloneDeep(rawProjectData.data.schema.fields);
            let dataTable = cloneDeep(rawProjectData.data.data);
            let now = new Date();

            renderTableData(columns, dataTable, now);
        }
    }, [rawProjectData, inputVariableTaker, tContext.formulaItems]);

    // Pagination
    // =============================================================================================================================
    useEffect(() => {
        setLoadingScroll(true);
        let currentProject = localStorage.getItem('activeProject');
        if (projectData.status === 'done' && hasNextPage) {
            getProjectDataToPagination(currentProject, currentPageToPagination)
                .then((res) => {
                    setRawProjectData(res);
                    setLoadingScroll(false);
                    setHasNextPage(res.data.has_next_page);
                })

                .catch((err) => {
                    console.log(err);
                });
        } else {
            setLoadingScroll(false);
        }
    }, [projectData, currentPageToPagination]);

    let maxId = 0;
    if (tContext.formulaItems.length) {
        let itemIds = tContext.formulaItems.map((item) => {
            return item.id;
        });

        maxId = Math.max.apply(Math, itemIds);
    }

    let caller_line = new Error().stack.split('\n')[4];

    const handleSetVariableFormula = (columnIndex) => {
        let items = cloneDeep(tContext.formulaItems);
        console.trace();
        items.push({
            id: maxId + 1,
            type: 'variable',
            text: 'C' + columnIndex,
            start: 'C' + columnIndex
        });
        tContext.setFormulaItems(items);
        tContext.setFormulaHistory(items);
    };

    const handleSetVariableConditional = (columnIndex, columnTransform) => {
        let fields = cloneDeep(rawProjectData.data.schema.fields);
        let columns = keyBy(fields, 'dataIndex');

        if (columns[columnIndex].conditional_transform)
            setConditionalItems(columns[columnIndex].conditional_transform);
    };

    const [vt] = useVT(
        () => ({
            onScroll: async ({ top, isEnd }) => {
                if (isEnd) {
                    setCurrentPageToPagination(currentPageToPagination + 1);
                }
            },
            scroll: {
                y: 800
            },
            debug: false
        }),
        [currentPageToPagination]
        // []
    );

    return (
        <>
            {appContext.helpNavIsVisible ? <HelpMenu /> : null}
            {loadingDataFromServer ? (
                <div
                    style={{
                        height: '100vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <Space>
                        {/* <Spin size="large" /> */}
                        <Loader />
                    </Space>
                </div>
            ) : (
                <Row wrap={false}>
                    {appContext.asideIsVisible ? (
                        <Col flex={'270px'}>
                            <SecondSiderTransform
                                conditionalItems={conditionalItems}
                                setConditionalItems={setConditionalItems}
                                tableColumn={tableColumn}
                                handleSetVariableFormula={
                                    handleSetVariableFormula
                                }
                                setRerenderTable={setRerenderTable}
                                rerenderTable={rerenderTable}
                                columnDbId={columnDbId}
                                setColumnDbId={setColumnDbId}
                                conditionalName={conditionalName}
                                setConditionalName={setConditionalName}
                                rawProjectData={rawProjectData}
                                conditionalTransform={conditionalTransform}
                                setConditionalTransform={
                                    setConditionalTransform
                                }
                                setTransformVisibleButton={
                                    setTransformVisibleButton
                                }
                                transformVisibleButton={transformVisibleButton}
                                refTable={refTable}
                            />
                        </Col>
                    ) : (
                        <SmallAside />
                    )}

                    <Col flex={'auto'}>
                        <HeaderProject
                            projectData={projectData}
                            rerenderProjectData={rerenderProjectData}
                            setRerenderProjectData={setRerenderProjectData}
                        />

                        <div className="desc-formula-container-box">
                            <div className="description">
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row'
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            transformVisibleButton ==
                                            'numerical'
                                                ? formulaDisplay(
                                                      tContext.formulaItems
                                                  )
                                                : functionFormulaDisplay(
                                                      conditionalItems
                                                  )
                                    }}
                                ></div>
                            </div>
                        </div>
                        <div ref={refTable}>
                            <Table
                                className="full-transform-view"
                                columns={tableColumn}
                                dataSource={tableData}
                                loading={loadingScroll}
                                scroll={{ x: 600, y: 'calc(100vh - 311px)' }}
                                pagination={false}
                                components={vt}
                                sticky
                            />
                        </div>
                    </Col>
                </Row>
            )}

            {isModalDeleteColumn && (
                <DeleteModal
                    visible={isModalDeleteColumn}
                    onCancel={handleModalDeleteColumn}
                    onAccept={handleDeleteColumn}
                    modalType="deleteColumn"
                />
            )}

            {isModalRenameColumn && (
                <RenameModal
                    visible={isModalRenameColumn}
                    onAccept={handleRenameColumn}
                    onCancel={handleModalRenameColumn}
                    handleNewRename={handleColumnName}
                    currentName={columnName}
                    modalType="renameColumn"
                />
            )}
        </>
    );
};

export default TransformView;
